import UserFirstLoginPage from "@/features/session/pages/UserFirstLogin";

const UserFirstLogin = () => {
  return <UserFirstLoginPage />;
};

export default UserFirstLogin;
